import Wrapper from './variation/Wrapper';
import Element from './variation/Element';

const Grid = {
    Wrapper: Wrapper,
    Element: Element,
};

export { Grid };